var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBalckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00002 2.66667L0.666687 4L4.66669 8L11.3334 1.33333L10 0L4.66669 5.33333L2.00002 2.66667Z",
    fill: "#11100E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBalckIcon);
export default __webpack_public_path__ + "static/media/check-balck-icon.18bb02679d92bda9e6f575122eb3869a.svg";
export { ForwardRef as ReactComponent };